import React, { FC, useMemo } from "react";
import classNames from "classnames";
import { KickAvatarIcon } from "@icons";
import { EntityIconList } from "@general/EntityIconList/EntityIconList";
import { Workspace } from "@common/types/workspace";
import styles from "./Commands.module.scss";
import { CommandItem } from "./CommandItem";

interface Props {
    index: number;
    workspace: Workspace;
    onSelected(): void;
}

export const WorkspaceCommandItem: FC<Props> = ({
    workspace,
    index,
    onSelected,
}) => {
    const entitiesToShow = useMemo(
        () => workspace.entities?.filter((e) => !!e.name) ?? [],
        [workspace.entities],
    );

    return (
        <CommandItem
            key={workspace.id}
            keywords={[
                "workspace",
                workspace.name,
                ...entitiesToShow.map((entity) => entity.name!),
            ]}
            onSelect={onSelected}
            shortcut={["O", (index + 1).toString()]}
        >
            <KickAvatarIcon
                className={classNames(styles.revert, styles.square)}
            />
            Open {workspace.name}{" "}
            {entitiesToShow.length > 0 ? (
                <EntityIconList
                    entities={entitiesToShow}
                    maxEntitiesToDisplay={Number.MAX_VALUE}
                    showLabel={false}
                />
            ) : null}
        </CommandItem>
    );
};
